<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>Zaposleni</v-toolbar-title>
    </v-toolbar>
  </v-card>
</template>
